import { useEffect } from 'react'
import Header from '../components/Header.jsx'
import Footer from '../components/Footer.jsx'
import { motion } from 'framer-motion'
import { ListChecks, Paintbrush, Save, RefreshCw, ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'

const sections = [
  {
    icon: ListChecks,
    title: '快速开始',
    steps: [
      '在首页点击「设置」，进入转盘选项列表。',
      '修改每个选项的名称、颜色和权重，自动保存到浏览器。',
      '点击「开始转动」，等待动画结束即可获得结果。',
    ],
  },
  {
    icon: Paintbrush,
    title: '主题与视觉',
    steps: [
      '在首页顶部编辑标题、副标题，敲回车即可保存。',
    ],
  },
  {
    icon: Save,
    title: '保存与复用',
    steps: [
      '点击「清空」可恢复到默认双选项状态。',
      '如果要导入示例，使用页面底部的「示例转盘」，会覆盖当前配置。',
      '转盘配置会自动保存在本地浏览器（localStorage）。',
    ],
  },

]

const UsageGuide = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 via-gray-100 to-gray-200 flex flex-col">
      <Header />

      <main className="flex-1">
        <div className="container mx-auto px-4 py-10 max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="mb-8"
          >
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-theme-600 hover:text-theme-700 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              返回首页
            </Link>
            <h1 className="mt-4 text-3xl md:text-4xl font-bold text-slate-900">使用说明</h1>
            <p className="mt-3 text-slate-600">
              按照以下步骤，你可以快速搭建和维护自己的转盘。遇到不清楚的地方，也可以回到首页体验后再对照查看。
            </p>
          </motion.div>

          <div className="grid gap-6">
            {sections.map(({ icon: Icon, title, steps }) => (
              <motion.section
                key={title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.35 }}
                className="rounded-2xl bg-white/80 backdrop-blur border border-slate-200 shadow-sm p-6"
              >
                <header className="flex items-center gap-3 mb-4">
                  <div className="rounded-full bg-theme-100 p-3 text-theme-600">
                    <Icon className="w-6 h-6" />
                  </div>
                  <h2 className="text-xl font-semibold text-slate-900">{title}</h2>
                </header>
                <ul className="list-disc list-inside space-y-2 text-slate-600">
                  {steps.map((step, index) => (
                    <li key={index}>{step}</li>
                  ))}
                </ul>
              </motion.section>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default UsageGuide

